import { StepEditorProps } from "../useStepEditor";
import { StepEditorAccordion } from "../../../workflows/routes/WorkflowEditor/StepEditorAccordion";
import { Block } from "../../../../components/atoms";

import { prefixForm } from "../../../../utils/FormUtils";
import { Stack, TextArea, Title } from "@introist/react-foundation/v2";
import { TagSelector } from "../../../system/tags/TagSelector";

export const AiActionStepEditor = ({ form, stepDataPath, workflowId }: StepEditorProps) => {
  const prefixedForm = prefixForm(form, stepDataPath);

  return (
    <>
      <Block blended compact>
        <Stack vertical>
          <StepEditorAccordion title="Instructions">
            <Stack vertical>
              <Title>Write detailed instructions for what the AI should do.</Title>
              <TextArea
                placeholder="Write your instructions here"
                value={prefixedForm.get("instructions")}
                onChange={prefixedForm.set("instructions")}
                rows={10}
              />
            </Stack>
          </StepEditorAccordion>
          <StepEditorAccordion title="Results">
            <Stack vertical>
              <Title>What should the AI produce.</Title>
              <StepEditorAccordion.Row label="Field">
                <TagSelector
                  onSelect={({ tag }) => {
                    prefixedForm.set("targetField")(tag);
                  }}
                  ctx={{ workflowId }}
                  value={prefixedForm.get("targetField")}
                  title="Select target field"
                />
              </StepEditorAccordion.Row>
            </Stack>
          </StepEditorAccordion>
        </Stack>
      </Block>
    </>
  );
};
